export interface DailyUsageBucket {
  used: number;
  cap: number;
  ratio: number;
}

export interface DailyUsageResponse {
  day: string;
  writes: DailyUsageBucket;
  deletes: DailyUsageBucket;
  readsTrackedExternally: true;
}

/**
 * Lê `/api/usage/today` (Admin SDK, `usage/{day}/shards|deleteShards`) — a mesma cota que
 * `firestore.rules` já aplica no servidor (`DAILY_WRITE_CAP`/`DAILY_DELETE_CAP`, ver
 * conectar.md, decisão de 2026-09-17). Sem cache local de propósito: são só 6 leituras baratas
 * por chamada, e este painel não é chamado em loop (só quando o módulo Geral do dashboard é
 * aberto) — não precisa do mesmo throttle de 5 min do sync de perfis.
 */
export async function fetchDailyUsage(idToken: string): Promise<DailyUsageResponse> {
  const res = await fetch('/api/usage/today', {
    headers: { Authorization: `Bearer ${idToken}` },
  });
  if (!res.ok) {
    throw new Error(`[/api/usage/today] HTTP ${res.status}`);
  }
  return (await res.json()) as DailyUsageResponse;
}
